import GroupsPanel from './GroupsPanel';
import { GroupsPanelProps, GroupsPanelValueProps } from './types';

export type { GroupsPanelProps, GroupsPanelValueProps };
export default GroupsPanel;
